import { sum, words } from 'lodash';
const getMaxLength = (s) => {
    let postMaxStr = s.split('maxlength')[1];
    return postMaxStr && postMaxStr.substring(postMaxStr.indexOf(':') + 1, postMaxStr.indexOf(';')).trim();
}
export default {
    getMaxLength
}
const evaluateExpression = (expression) => {
    let tokens = expression.split(/\W+/).map(exp=> parseInt(exp));
    let match = tokens.pop();
    if (expression.includes('>=')) {
      return sum(tokens) >= match;
    } else if (expression.includes('==') || expression.includes('===')) {
      return sum(tokens) == match;
    } else {
      return sum(tokens) > match;
    }
}
export const verifyGroupExpression = (group) => {
    let expression = group?.exp;
    const rules = group.rule;
    if (expression?.length > 0) {
      let tokens = words(expression, /[A-z](?:_?[A-z0-9]+)/g);
      tokens = tokens.map((token) => {
        const rule = rules.filter((item) => item.ruleId === token);
        let isCompleted = null;
        rule.length > 0 ? (isCompleted = rule[0].completed) : (isCompleted = 0);
        expression = expression.replace(token, isCompleted);
      });
      return evaluateExpression(expression.trim());
    } else {
      return true;
    }
  };
export const getDescription = (exp, tokens) => {
    if (exp.includes('>=')) {
      return `Include atleast ${exp[exp.length - 1]} of the following:`;
    } else {
      return `Include atleast ${
        parseInt(exp[exp.length - 1]) + 1
      } of the following:`;
    }
  };

  export const verifyExpression = (userDetails,rules) => {
    let expression = userDetails?.expression;
    if (expression?.length > 0) {
        let tokens = words(expression, /[A-z](?:_?[A-z0-9]+)/g);
        tokens = tokens.map((token) => {
        const rule = rules.filter((item) => item.ruleId === token);
        let isCompleted = null;
        (rule.length > 0) ? isCompleted = rule[0].completed : isCompleted = 0;
        expression = expression.replace(token, isCompleted);
        });
        return !evaluateExpressionOld(expression);
    } else {
        return true
    }
}

export const evaluateExpressionOld = (expression) => {
	let tokens = expression.split(/\W+/).map(exp=> parseInt(exp));
	let match = tokens.pop();
	return sum(tokens) == match;
}